export { default } from './Info';
export type { Props, Props as InfoProps } from './Info';
